import * as Comlink from 'comlink';
/* eslint-disable import/no-webpack-loader-syntax */
import Worker from 'worker-loader!../workers/log-worker';
import { getApiHost } from './hosts';

let wLogger: any;
let user: any;
const device = navigator.userAgent;
let session: any;
let bandwidth: any;
let state: any;
let is_reload = false;

//have to initialize worker in an async function, so do it here in a closure
(async function init() {
	const worker = new Worker();
	wLogger = Comlink.wrap(worker) as any;
	wLogger.setEndpoint(getApiHost());
})();

export function setUser(_user: any) {
	user = _user;
}

export function setSession(_session: string) {
	session = _session;
}

export function setBandwidth(_bandwidth: any) {
	bandwidth = _bandwidth;
}

export function setState(_state: any) {
	state = _state;
}

//another closure to get whether the page was a refresh or a direct load
(function () {
	// Use getEntriesByType() to just get the "navigation" events
	const perfEntries = performance.getEntriesByType('navigation');

	for (let i = 0; i < perfEntries.length; i++) {
		// @ts-ignore
		if (perfEntries[i].type === 'reload') {
			is_reload = true;
		}
	}
})();

//handle logger
export function log(message: any) {
	if (wLogger) {
		try {
			wLogger.store(JSON.stringify({
				gr_user: user?.gr_user,
				user_agent: device,
				meeting: state?.meeting?.meeting,
				//state,
				invitation: state?.invitation,
				url: window.location.href,
				type: Object.keys(message)[0],
				bitrate: bandwidth,
				is_reload,
				message,
				local_session: session,
			}));
		} catch (e) {
			console.log(e);
		}
	}
}